import React, { useEffect, useState } from "react";
import MaterialWrapper from "app/material-framework/MaterialWrapper";
import { Box, Paper, Grid, Draggable } from "app/material-framework/materialComponents";
import parse from "html-react-parser";
import { sanitizeHtml } from "utils/sanitizeHtml";
import { ChatbotComponents } from "./ChatbotComponents";
import { useChatbotController } from "./hooks/useChatbotController";
import LoadingPopoutSkeleton from "../app/material-framework/LoadingPopoutSkeleton";
import LoadingPanelSkeleton from "../app/material-framework/LoadingPanelSkeleton";

export function ChatResponse({ html, fullscreen }) {
  /* const handleCopy = () => {
    const { textContent } = new DOMParser().parseFromString(html, "text/html").body;
    navigator.clipboard
      .writeText(textContent)
      .then(() => {
        console.log("Text copied");
      })
      .catch((err) => {
        console.error("Failed to copy text:", err);
      });
  };

  const handleEmail = () => {
    const { textContent } = new DOMParser().parseFromString(html, "text/html").body;
    const subject = "Chatbot Response";
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(textContent)}`;
  }; */

  return (
    <Grid container spacing={0} sx={{ width: "100%" }}>
      <Grid item>
        <Box
          sx={{
            fontSize: 14,
          }}
        >
          {parse(sanitizeHtml(html))}
        </Box>
      </Grid>

      {/* <Grid item sx={{ width: "100%" }}>
        <Box sx={{ display: "flex", gap: 1, mt: 1, justifyContent: "end" }}>
          <Tooltip title="Copy text">
            <IconButton
              size="small"
              onClick={handleCopy}
              sx={{
                bgcolor: "#F5F5F5",
                "&:hover": { bgcolor: "#E0E0E0" },
              }}
            >
              <FontAwesomeIcon icon={faCopy} size="sm" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Email">
            <IconButton
              size="small"
              onClick={handleEmail}
              sx={{
                bgcolor: "#F5F5F5",
                "&:hover": { bgcolor: "#E0E0E0" },
              }}
            >
              <FontAwesomeIcon icon={faEnvelope} size="sm" />
            </IconButton>
          </Tooltip>
        </Box>
      </Grid> */}
    </Grid>
  );
}

export function ChatbotPanel({
  onClose,
  panelWidth,
  setPanelWidth,
  onPopStateChange,
  onFullscreenChange,
  publicationId,
  isHtmlReport,
  initialTab,
  initialQuery,
}) {
  const controller = useChatbotController({ publicationId, isHtmlReport, initialTab });
  const { fullscreen, customTheme } = controller;
  const [isPopout, setIsPopout] = useState(false);
  const [chatPanelOpen, setChatPanelOpen] = useState(true);

  useEffect(() => {
    onFullscreenChange?.(fullscreen);
  }, [fullscreen, onFullscreenChange]);

  useEffect(() => {
    if (initialQuery) {
      controller.handleSend(initialQuery);
    }
  }, []);
  useEffect(() => {
    const handler = (e) => {
      const query = e.detail?.query;
      if (query) controller.handleSend(query);
    };
    window.addEventListener("naira-send-query", handler);
    return () => window.removeEventListener("naira-send-query", handler);
  }, [controller.handleSend]);

  const setPopoutState = (popout) => {
    setIsPopout(popout);
    setChatPanelOpen(!popout);
    onPopStateChange(popout);
  };

  const handleDragWidth = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = panelWidth;
    function onMove(ev) {
      const deltaX = startX - ev.clientX;
      const newWidth = Math.min(Math.max(startWidth + deltaX, 235), window.innerWidth * 0.85);
      setPanelWidth(newWidth);
    }
    function onUp() {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    }
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  };

  return (
    <MaterialWrapper
      customTheme={customTheme}
      onClose={onClose}
      fallback={isHtmlReport ? <LoadingPopoutSkeleton /> : <LoadingPanelSkeleton />}
      errorVariant={isHtmlReport ? "popout" : "panel"}
    >
      {isPopout && (
        <Draggable handle=".chatbot-header, .chat-input-area" defaultPosition={{ x: 0, y: 0 }}>
          <Paper
            elevation={16}
            style={{
              position: "fixed",
              bottom: 24,
              right: 24,
              width: 460,
              minWidth: 280,
              maxWidth: 500,
              zIndex: 1030,
              height: "80vh",
              display: "flex",
              flexDirection: "column",
              borderRadius: 18,
              overflow: "hidden",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
              bgcolor: "#00000008",
              border: "2px solid #E0E0E0",
              padding: 4
            }}
          >
            <ChatbotComponents
              controller={controller}
              isPopout
              onTogglePopout={() => setPopoutState(false)}
              onClose={onClose}
            />
          </Paper>
        </Draggable>
      )}
      {chatPanelOpen && (
        <Paper
          elevation={6}
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            width: fullscreen ? "99vw" : panelWidth,
            minWidth: fullscreen ? "99vw" : 235,
            maxWidth: fullscreen ? "99vw" : "85vw",
            left: fullscreen ? 0 : "auto",
            height: "100vh",
            zIndex: 20,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#F5F5F5",
            borderLeft: "1px solid #D9D9D9",
            borderRadius: 0,
            transition: "width 0.1s",
            fontFamily: `"ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro",メイリオ,Meiryo,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important`,
          }}
        >
          <ChatbotComponents
            controller={controller}
            isPopout={false}
            onTogglePopout={() => setPopoutState(true)}
            onClose={onClose}
            onWidthDrag={handleDragWidth}
          />
        </Paper>
      )}
    </MaterialWrapper>
  );
}
